import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "overflow-ellipsis" }
const _hoisted_2 = {
  key: 0,
  class: "coral-coral-color fs-larger",
  style: {"padding-bottom":"3px"}
}
const _hoisted_3 = {
  key: 1,
  class: "coral-coral-color fs-larger",
  style: {"padding-bottom":"3px"}
}
const _hoisted_4 = {
  class: "overflow-ellipsis fw-bolder",
  style: {"padding-bottom":"3px"}
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "coral-coral-color" }
const _hoisted_7 = {
  key: 3,
  class: "overflow-ellipsis-row-2"
}
const _hoisted_8 = { class: "coral-coral-color" }
const _hoisted_9 = { class: "coral-coral-color" }

import { IonAccordion, IonCol, IonGrid, IonRow } from "@ionic/vue";
import { computed, ref } from "vue";

import ButtonDelete from "@/components/button/ButtonDelete.vue";
import TimerSettings from "@/components/TimerSettings.vue";
import SkeletonBase from "@/components/various/SkeletonBase.vue";

import { useUserStore } from "@/stores/user";

import { translateJoin } from "@/functions/converter";
import { weekdaySort } from "@/functions/sort";
import convertFormat from "@/functions/luxon";

import { REPEAT_CYCLE, WEEKDAY } from "@/types/enum/general";
import { DATE_FORMAT, TIME_FORMAT } from "@/types/enum/luxonEnum";
import { PERMISSION_KEY } from "@/types/user";
import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { OrderTimerProps } from "@/types/props";
import { OrderTimerEmits } from "@/types/emits";
import { requiresPermission } from "@/functions/check";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderTimer',
  props: {
    timer: {},
    listId: {},
    cssClass: {},
    settings: { type: Boolean },
    gridColor: { default: 'grey4-grey4-background' }
  },
  emits: ["deleteTimer", "editTimer"],
  setup(__props: any) {

const userStore = useUserStore()

const props = __props


const timerName = ref(String(props.timer.name))

const sortedTimer = computed<Array<WEEKDAY>>(() => {
    const sorted = props.timer
    return sorted.interval.days.sort(weekdaySort)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonRow), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCol), { class: "my-1" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("div", {
              class: "line octo-gradient-light-background",
              style: {"height":"1px"}
            }, null, -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonAccordion), {
      class: "bg-transparent",
      style: {"overflow":"visible"}
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonGrid), {
          slot: "header",
          class: _normalizeClass(["ion-no-padding card-border light-medium-shadow", __props.gridColor])
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRow), {
              class: _normalizeClass(["pl-4 purple-purple-color d-flex", (!_ctx.$route.params.listId) ? 'timer-entry' : 'timer-entry-small'])
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), {
                  class: "center-y py-1",
                  style: {"max-width":"calc(100% - 56px)"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      (__props.timer.type === _unref(REPEAT_CYCLE).ONCE)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(convertFormat)(__props.timer.date, 'iso', _unref(TIME_FORMAT).DE)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.timer.interval.time), 1)),
                      _createVNode(SkeletonBase, {
                        show: !__props.timer && !timerName.value,
                        variants: { dark: _unref(ION_VARIANT).PURPLE }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, _toDisplayString(timerName.value), 1)
                        ]),
                        _: 1
                      }, 8, ["show", "variants"]),
                      (__props.timer.type === _unref(REPEAT_CYCLE).ONCE)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createTextVNode(_toDisplayString(_ctx.$t(`enumT.repeatCycle.${_unref(REPEAT_CYCLE).ONCE}`)) + " " + _toDisplayString(_ctx.$t('label.at')) + " ", 1),
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(convertFormat)(__props.timer.date, 'iso', _unref(DATE_FORMAT).DE)), 1)
                          ]))
                        : (__props.timer.interval.days)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createTextVNode(_toDisplayString(_ctx.$t('messages.list.repeatEach2')) + " ", 1),
                              _createElementVNode("span", _hoisted_8, _toDisplayString(__props.timer.interval?.every ?? ''), 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(`enumT.repeatCycle.appendix.${__props.timer.type}`)) + " " + _toDisplayString(_ctx.$t('label.at')) + " ", 1),
                              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(translateJoin)(sortedTimer.value, 'enumT.weekday.', ', ')), 1)
                            ]))
                          : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                (_unref(requiresPermission)(_unref(PERMISSION_KEY).LIST_REMINDER_DELETE))
                  ? (_openBlock(), _createBlock(_unref(IonCol), {
                      key: 0,
                      size: "auto",
                      class: "center-y",
                      style: {"justify-self":"end"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ButtonDelete, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('deleteTimer', { id: __props.timer.id, listId: __props.timer.listId })))
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }, 8, ["class"]),
        (_unref(userStore).permission[_unref(PERMISSION_KEY).LIST_REMINDER_UPDATE])
          ? (_openBlock(), _createBlock(_unref(IonGrid), {
              key: 0,
              slot: "content",
              class: "light-coral-color p-2"
            }, {
              default: _withCtx(() => [
                _createVNode(TimerSettings, {
                  "css-class": __props.cssClass,
                  timer: __props.timer,
                  settings: __props.settings,
                  onEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('editTimer', $event)))
                }, null, 8, ["css-class", "timer", "settings"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})